import i18n from "../../locales/i18n";
import React from "react";
import { View, ActivityIndicator, Text } from "react-native";

export default function Loader() {
  return (
    <View className="flex justify-center gap-y-2 items-center h-full w-full bg-white">
      <ActivityIndicator size={80} color="rgba(5, 150, 208, 1)" />
      <Text className="text-2xl">{i18n.t("loading")}</Text>
    </View>
  );
}
